module.exports = __webpack_public_path__ + "media/images/icon__point--default@3x-fdfbacadb36862661bc67ff66c96810d.png";